// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2PuJf","description":"PatientConsentPreview_description__3zLyI"};